import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Mentoria', path: '/mentoria' },
    { name: 'Consultoria', path: '/consultoria' },
    { name: 'Agentes IA', path: '/agentes-ia' },
    { name: 'Sobre Nós', path: '/sobre' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="bg-gradient-to-r from-emerald-600 via-emerald-500 to-teal-500 text-white text-center py-3 px-4">
        <span className="inline-flex items-center gap-3 flex-wrap justify-center">
          <span className="bg-white/20 rounded-full px-3 py-0.5 text-xs font-bold uppercase tracking-widest">
            🎁 Bônus Exclusivo
          </span>
          <span className="text-base font-semibold">
            Ao se inscrever hoje, você recebe acesso à{' '}
            <strong className="underline decoration-white/60 underline-offset-2">Central Pedagógica</strong>
            {' '}com <strong>Assistentes de IA</strong> configurados para professores
          </span>

        </span>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src="https://static.readdy.ai/image/a5ad98cef7fb0013710af7dda5c63c4b/1bdc9ff35c3391c1d6e2109623d91117.png"
              alt="ViaEducacaoCursos"
              className="h-10 w-10 transition-transform duration-300 group-hover:scale-110"
            />
            <span className={`text-xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              ViaEducacaoCursos
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-300 hover:text-purple-600 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-purple-600'
                    : isScrolled
                    ? 'text-gray-700'
                    : 'text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-4">
          </div>
        </div>
      </div>
    </nav>
  );
}